import
  React
from 'react';

import {
  PropTypes
} from 'prop-types';

import {
  Base,
  ColorSvg,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

export const Hero = props => {

  return (

      <VContainer
        background={
          props.background
            ? `${CustomColors.Black} url(${props.background}) center 100% no-repeat`
            : `${CustomColors.Black}`
        }
        minHeight={props.bannerHeight}
        style={styles.hero}>

        <Base
          style={props.useOverLay ? styles.overlay : {}}
          padding={props.bannerPadding}
          color={CustomColors.White}
          display={'block'}>

          <Text
            padding={props.subtitlePadding}
            fontSize={props.subtitleFontSize}
            color={CustomColors.White}
            fontWeight={props.subtitleFontWieght}
            dangerouslySetInnerHTML={{
              __html: `${props.subtitle}`
            }} />

          <Text
            padding={props.titlePadding}
            fontSize={props.titleFontSize}
            color={CustomColors.White}
            fontWeight={'bold'}>
            {props.title}
          </Text>

          <Text
            display={'inline'}
            dangerouslySetInnerHTML={{
              __html: `${props.caption}`
            }} />

          <Text
            display={'inline'}
            fontWeight={props.clickOutFontWeight}
            color={CustomColors.White}
            onClick={props.onClick}
            textDecoration={props.clickOutUnderline ? 'underline' : 'none'}>

            {props.clickOutText}
          </Text>

          {
            props.clickOutText && !props.clickOutUnderline &&
            <VContainer
              padding={'0 4px'}
              display={'inline-block !important'}
              color={CustomColors.White}>
              <ColorSvg
                  width={'12px'}
                  height={'12px'}
                  src={Icons.ForwardArrow} />
            </VContainer>
          }
        </Base>
      </VContainer>
    );
};

const styles = {
  hero: {
    backgroundSize: 'cover',
    backgroundPosition: 'top center'
  },
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.45)'
  }
};

Hero.propTypes = {
  background: PropTypes.string.isRequired,
  bannerHeight: PropTypes.string,
  bannerPadding: PropTypes.string,
  useOverlay: PropTypes.bool,
  subtitle: PropTypes.string,
  subtitleFontSize: PropTypes.string,
  title: PropTypes.string,
  titleFontSize: PropTypes.string,
  caption: PropTypes.string,
  clickOutText: PropTypes.string,
  clickOutUnderline: PropTypes.bool
};

Hero.defaultProps = {
  background: '',
  bannerHeight: '235px',
  bannerPadding: '16px',
  useOverLay: false,
  subtitle: '',
  subtitleFontSize: '20px',
  subtitlePadding: '64px 0 0 0',
  subtitleFontWieght: 'bold',
  title: '',
  titleFontSize: '26px',
  titlePadding: '8px 0 16px 0',
  caption: '',
  captionFontWeight: 'inherit',
  clickOutText: '',
  clickOutFontWeight: '500',
  clickOutUnderline: false,
  onClick: () => {}
};